export default {
  "AddOnComponents": {
    "id": "AddOnComponents",
    "name": " Add On Components",
    "children": [
      "AddingMotion",
      "GravityRollerComponents",
      "Stanchions"
    ],
    "defaultParts": {}
  },
  "AddingMotion": {
    "id": "AddingMotion",
    "name": " Linear Motion",
    "children": [
      // "HighCycleLinearBearings",
      "RollerWheels",
      "LinearBearingPads",
      "Unibearings",
      "StandardLinearBearings",
      "LinearBearingShimsAndBrakes",
    ],
    "defaultParts": {}
  },
  "RollerWheels": {
    "id": "RollerWheels",
    "name": "Roller Wheels",
    "children": [],
    "defaultParts": {}
  },
  "HighCycleLinearBearings": {
    "id": "HighCycleLinearBearings",
    "name": " High Cycle Linear Bearings",
    "children": [
      // "3SlotMountDoubleFlangeLongHighCycleLinearBearing",
      // "3SlotMountDoubleFlangeLongHighCycleLinearBearingWithBrakeHoles",
      // "3SlotMountDoubleFlangeShortHighCycleLinearBearing",
      // "3SlotMountDoubleFlangeShortHighCycleLinearBearingWithBrakeHoles",
      // "3SlotMountSingleFlangeLongHighCycleLinearBearing",
      // "3SlotMountSingleFlangeLongHighCycleLinearBearingWithBrakeHoles",
      // "3SlotMountSingleFlangeShortHighCycleLinearBearing",
      // "3SlotMountSingleFlangeShortHighCycleLinearBearingWithBrakeHoles",
      // "4SlotMountDoubleFlangeLongHighCycleLinearBearing",
      // "4SlotMountDoubleFlangeLongHighCycleLinearBearingWithBrakeHoles",
      // "4SlotMountDoubleFlangeShortHighCycleLinearBearing",
      // "4SlotMountDoubleFlangeShortHighCycleLinearBearingWithBrakeHoles"
    ],
    "defaultParts": {}
  },
  "S_15": {
    "id": "S_15",
    "name": " S_15",
    "children": [],
    "defaultParts": {}
  },
  "S_40": {
    "id": "S_40",
    "name": " S_40",
    "children": [],
    "defaultParts": {}
  },
  "S_45": {
    "id": "S_45",
    "name": " S_45",
    "children": [],
    "defaultParts": {}
  },
  "LinearBearingPads": {
    "id": "LinearBearingPads",
    "name": " Linear Bearing Pads",
    "children": [
      "DoubleKeyedStandardBearingPadProfile",
      "DoubleKeyedUnibearingPads",
      "SingleKeyedHighCycleLinearBearingPads",
      "SingleKeyedStandardBearingPadProfiles",
      "SingleKeyedStandardLinearBearingPads",
      "SingleKeyedUnibearingPads",
      "T-SlotInsertLinearBearingPads"
    ],
    "defaultParts": {}
  },
  "DoubleKeyedStandardBearingPadProfile": {
    "id": "DoubleKeyedStandardBearingPadProfile",
    "name": " Double Keyed Standard Bearing Pad Profile",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "S_10": {
    "id": "S_10",
    "name": " S_10",
    "children": [],
    "defaultParts": {}
  },
  "S_25": {
    "id": "S_25",
    "name": " S_25",
    "children": [],
    "defaultParts": {}
  },
  "DoubleKeyedUnibearingPads": {
    "id": "DoubleKeyedUnibearingPads",
    "name": " Double Keyed Unibearing Pads",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "SingleKeyedHighCycleLinearBearingPads": {
    "id": "SingleKeyedHighCycleLinearBearingPads",
    "name": " Single Keyed High Cycle Linear Bearing Pads",
    "children": [
      "S_15",
      "S_40"
    ],
    "defaultParts": {}
  },
  "SingleKeyedStandardBearingPadProfiles": {
    "id": "SingleKeyedStandardBearingPadProfiles",
    "name": " Single Keyed Standard Bearing Pad Profiles",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "SingleKeyedStandardLinearBearingPads": {
    "id": "SingleKeyedStandardLinearBearingPads",
    "name": " Single Keyed Standard Linear Bearing Pads",
    "children": [
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "SingleKeyedUnibearingPads": {
    "id": "SingleKeyedUnibearingPads",
    "name": " Single Keyed Unibearing Pads",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "T-SlotInsertLinearBearingPads": {
    "id": "T-SlotInsertLinearBearingPads",
    "name": " T- Slot Insert Linear Bearing Pads",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "LinearBearingShimsAndBrakes": {
    "id": "LinearBearingShimsAndBrakes",
    "name": " Linear Bearing Brakes",
    "children": [
      "LinearBearingShimStock"
    ],
    "defaultParts": {}
  },
  "LinearBearingShimStock": {
    "id": "LinearBearingShimStock",
    "name": " Linear Bearing Shim Stock",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "StandardLinearBearings": {
    "id": "StandardLinearBearings",
    "name": " Standard Linear Bearings",
    "children": [
      // "3SlotMountDoubleFlangeLongStandardLinearBearing",
      // "3SlotMountDoubleFlangeLongStandardLinearBearingWithBrakeHoles",
      // "3SlotMountDoubleFlangeShortStandardLinearBearing",
      // "3SlotMountDoubleFlangeShortStandardLinearBearingWithBrakeHoles",
      // "3SlotMountSingleFlangeLongStandardLinearBearing",
      // "3SlotMountSingleFlangeLongStandardLinearBearingWithBrakeHoles",
      // "3SlotMountSingleFlangeShortStandardLinearBearing",
      // "3SlotMountSingleFlangeShortStandardLinearBearingWithBrakeHoles",
      // "4SlotMountDoubleFlangeLongStandardLinearBearing",
      // "4SlotMountDoubleFlangeLongStandardLinearBearingWithBrakeHoles",
      // "4SlotMountDoubleFlangeShortStandardLinearBearing",
      // "4SlotMountDoubleFlangeShortStandardLinearBearingWithBrakeHoles"
    ],
    "defaultParts": {}
  },
  "Unibearings": {
    "id": "Unibearings",
    "name": " Unibearings",
    "children": [
      // "DoubleLongUnibearing",
      // "DoubleShortUnibearing",
      // "LongDoubleMountUnibearingAssembly",
      // "LongSingleMountUnibearingAssembly",
      // "ShortDoubleMountUnibearingAssembly",
      // "ShortSingleMountUnibearingAssembly",
      // "SingleLongUnibearing",
      // "SingleShortUnibearing"
    ],
    "defaultParts": {}
  },
  "DoubleLongUnibearing": {
    "id": "DoubleLongUnibearing",
    "name": " Double Long Unibearing",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "DoubleShortUnibearing": {
    "id": "DoubleShortUnibearing",
    "name": " Double Short Unibearing",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "LongDoubleMountUnibearingAssembly": {
    "id": "LongDoubleMountUnibearingAssembly",
    "name": " Long Double Mount Unibearing Assembly",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "LongSingleMountUnibearingAssembly": {
    "id": "LongSingleMountUnibearingAssembly",
    "name": " Long Single Mount Unibearing Assembly",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "ShortDoubleMountUnibearingAssembly": {
    "id": "ShortDoubleMountUnibearingAssembly",
    "name": " Short Double Mount Unibearing Assembly",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "ShortSingleMountUnibearingAssembly": {
    "id": "ShortSingleMountUnibearingAssembly",
    "name": " Short Single Mount Unibearing Assembly",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "SingleLongUnibearing": {
    "id": "SingleLongUnibearing",
    "name": " Single Long Unibearing",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "SingleShortUnibearing": {
    "id": "SingleShortUnibearing",
    "name": " Single Short Unibearing",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "GravityRollerComponents": {
    "id": "GravityRollerComponents",
    "name": " Gravity Roller Components",
    "children": [
      "GravityRoller",
      "GravityRollerMountingBlock"
    ],
    "defaultParts": {}
  },
  "GravityRoller": {
    "id": "GravityRoller",
    "name": " Gravity Roller",
    "children": [
      "S_15-S_40-S_45"
    ],
    "defaultParts": {}
  },
  "S_15-S_40-S_45": {
    "id": "S_15-S_40-S_45",
    "name": " S_15- S_40- S_45",
    "children": [],
    "defaultParts": {}
  },
  "GravityRollerMountingBlock": {
    "id": "GravityRollerMountingBlock",
    "name": " Gravity Roller Mounting Block",
    "children": [
      "S_15-S_40-S_45"
    ],
    "defaultParts": {}
  },
  "Stanchions": {
    "id": "Stanchions",
    "name": " Stanchions",
    "children": [
      "DoubleShaftBlankStanchionMountingPlate",
      "DoubleShaftStanchionBase",
      "DoubleShaftStanchionMountingBlock",
      "HorizontalStanchionQuickClamp",
      "NarrowHorizontalStanchionBase",
      "QuickStanchionCrossClamp",
      "SingleShaftBlankStanchionMountingPlate",
      "SingleShaftPreDrilledStanchionMountingPlate",
      "SingleShaftStanchionBase",
      "SingleShaftStanchionMountingBlock",
      "StanchionClampHandle",
      "StanchionCrossClamp",
      "WideHorizontalStanchionBase"
    ],
    "defaultParts": {}
  },
  "DoubleShaftBlankStanchionMountingPlate": {
    "id": "DoubleShaftBlankStanchionMountingPlate",
    "name": " Double Shaft Blank Stanchion Mounting Plate",
    "children": [
      "S_15"
    ],
    "defaultParts": {}
  },
  "DoubleShaftStanchionBase": {
    "id": "DoubleShaftStanchionBase",
    "name": " Double Shaft Stanchion Base",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "DoubleShaftStanchionMountingBlock": {
    "id": "DoubleShaftStanchionMountingBlock",
    "name": " Double Shaft Stanchion Mounting Block",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "HorizontalStanchionQuickClamp": {
    "id": "HorizontalStanchionQuickClamp",
    "name": " Horizontal Stanchion Quick Clamp",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "NarrowHorizontalStanchionBase": {
    "id": "NarrowHorizontalStanchionBase",
    "name": " Narrow Horizontal Stanchion Base",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "QuickStanchionCrossClamp": {
    "id": "QuickStanchionCrossClamp",
    "name": " Quick Stanchion Cross Clamp",
    "children": [
      "Fractional"
    ],
    "defaultParts": {}
  },
  "Fractional": {
    "id": "Fractional",
    "name": " Fractional",
    "children": [],
    "defaultParts": {}
  },
  "SingleShaftBlankStanchionMountingPlate": {
    "id": "SingleShaftBlankStanchionMountingPlate",
    "name": " Single Shaft Blank Stanchion Mounting Plate",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "SingleShaftPreDrilledStanchionMountingPlate": {
    "id": "SingleShaftPreDrilledStanchionMountingPlate",
    "name": " Single Shaft Pre Drilled Stanchion Mounting Plate",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "SingleShaftStanchionBase": {
    "id": "SingleShaftStanchionBase",
    "name": " Single Shaft Stanchion Base",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "SingleShaftStanchionMountingBlock": {
    "id": "SingleShaftStanchionMountingBlock",
    "name": " Single Shaft Stanchion Mounting Block",
    "children": [
      "S_15"
    ],
    "defaultParts": {}
  },
  "StanchionClampHandle": {
    "id": "StanchionClampHandle",
    "name": " Stanchion Clamp Handle",
    "children": [
      "Fractional"
    ],
    "defaultParts": {}
  },
  "StanchionCrossClamp": {
    "id": "StanchionCrossClamp",
    "name": " Stanchion Cross Clamp",
    "children": [
      "S_15"
    ],
    "defaultParts": {}
  },
  "WideHorizontalStanchionBase": {
    "id": "WideHorizontalStanchionBase",
    "name": " Wide Horizontal Stanchion Base",
    "children": [
      "S_10",
      "S_15"
    ],
    "defaultParts": {}
  },
  "ExternalFasteners": {
    "id": "ExternalFasteners",
    "name": "External Connecters",
    "children": [
      "FlatJoiningPlates",
      "BracketsAndGussetsAndCorners",
    ],
    "defaultParts": {
      "10": [ "4107", "4119", "4081", "4115", "4151", "4113", "4167", "4114", "4118", "4132", "4166", "4136", "4128", "4138"], 
      "15": [ "4307", "4302", "4481", "4301", "4351", "4303", "4367", "4304", "4306", "4332", "4366", "4336", "4328", "4338", "4442"],
      "20": [ "20-4107", "20-4119", "20-4081", "20-4113", "20-4151", "20-4176", "20-4167", "20-4118", "20-4166", "20-4080"],
      "25": [ "25-4107", "25-4119", "25-4081", "25-4115", "25-4151", "25-4113", "25-4167", "25-4114", "25-4118", "25-4132", "25-4166", "25-4136", "25-4080", "25-4134", "25-4138"], 
      "30": [ "30-4307", "30-4302", "30-4481", "30-4303", "30-4351", "30-4332", "30-4367", "30-4336", "30-4318", "30-4134", "30-4366", "30-4348", "30-4380"],
      "40": [ "40-4307", "40-4302", "40-4481", "40-4301", "40-4351", "40-4303", "40-4367", "40-4304", "40-4318", "40-4332", "40-4366", "40-4336", "40-4380", "40-4334"], 
      "45": [ "45-4307", "45-4302", "45-4481", "45-4301", "45-4351", "45-4303", "45-4367", "45-4304", "45-4318", "45-4332", "45-4366", "45-4336", "45-4380", "45-4334"], 
    }
  },
  "BracketsAndGussetsAndCorners": {
    "id": "BracketsAndGussetsAndCorners",
    "name": "Corner Brackets",
    "children": [
      "StandardCornerBrackets",
      "TallCornerBrackets",
      "WideCornerBrackets",
      "StandardGussetedBrackets",
      "TallGussetedBrackets",
      "WideGussetedBrackets",
      "TriConnectionCornerBrackets",
      "CenteredCornerBrackets",
      "TransitionCornerBrackets",
    ],
    "defaultParts": {
      "10": ["4119", "4115", "4113", "4114", "4132", "4136", "4138", "4042"],
      "15": ["4302", "4301", "4303", "4304", "4332", "4336", "4338", "4442"],
      "20": ["20-4119", "20-4113", "20-4176"],
      "25": ["25-4119", "25-4115", "25-4113", "25-4114", "25-4132", "25-4136", "25-4134", "25-4138"],
      "30": ["30-4302", "30-4303", "30-4332", "30-4336", "30-4134", "30-4348",],
      "40": ["40-4302", "40-4301", "40-4303", "40-4304", "40-4332", "40-4336", "40-4334", "40-4338", "40-4443"],
      "45": ["45-4302", "45-4301", "45-4303", "45-4304", "45-4332", "45-4336", "45-4334", "45-4338"]
    }
  },
  "CenteredCornerBrackets": {
    "id": "CenteredCornerBrackets",
    "name": " Centered",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "StandardCornerBrackets": {
    "id": "StandardCornerBrackets",
    "name": " Standard",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {
      "10": ["4119", "4108", "4114", "4176", "4017"],
      "15": ["4302", "4304", "4376", "4417"],
      "20": [],
      "25": [],
      "30": [],
      "40": [],
      "45": []
    }
  },
  "S_20": {
    "id": "S_20",
    "name": " S_20",
    "children": [],
    "defaultParts": {}
  },
  "S_30": {
    "id": "S_30",
    "name": " S_30",
    "children": [],
    "defaultParts": {}
  },
  "StandardGussetedBrackets": {
    "id": "StandardGussetedBrackets",
    "name": " Standard Gusseted",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "TallCornerBrackets": {
    "id": "TallCornerBrackets",
    "name": " Tall",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40",
      "S_45"
    ],
    "defaultParts": {
      "10": ["4115", "4101", "4013", "4014"],
      "15": ["4301", "4413", "4414"],
      "20": [],
      "25": [],
      "30": [],
      "40": [],
      "45": []
    }
  },
  "TallGussetedBrackets": {
    "id": "TallGussetedBrackets",
    "name": " Tall Gusseted",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "TransitionCornerBrackets": {
    "id": "TransitionCornerBrackets",
    "name": " Transition",
    "children": [
      "S_10-S_15",
      "S_25-S_40"
    ],
    "defaultParts": {}
  },
  "S_10-S_15": {
    "id": "S_10-S_15",
    "name": " S_10- S_15",
    "children": [],
    "defaultParts": {}
  },
  "S_25-S_40": {
    "id": "S_25-S_40",
    "name": " S_25- S_40",
    "children": [],
    "defaultParts": {}
  },
  "TriConnectionCornerBrackets": {
    "id": "TriConnectionCornerBrackets",
    "name": " 3-Way Connection",
    "children": [
      "S_10",
      "S_10-S_25",
      "S_15",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "S_10-S_25": {
    "id": "S_10-S_25",
    "name": " S_10- S_25",
    "children": [],
    "defaultParts": {}
  },
  "WideCornerBrackets": {
    "id": "WideCornerBrackets",
    "name": " Wide",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {
      "10": ["4113", "4015", "4175", "4016", "4260"],
      "15": ["4303", "4415", "4375", "4416"],
      "20": [],
      "25": [],
      "30": [],
      "40": [],
      "45": []
    }
  },
  "WideGussetedBrackets": {
    "id": "WideGussetedBrackets",
    "name": " Wide Gusseted",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "FlatJoiningPlates": {
    "id": "FlatJoiningPlates",
    "name": "Flat Plates",
    "children": [
      "StraightPlates",
      "SquarePlates",
      "RectangularPlates",
      "RightAnglePlates",
      "AngledPlates",
      "CrossPlates",
      "TeePlates",
      "TransitionPlates"
    ],
    "defaultParts": {
      "10": ["4107", "4081", "4151", "4167", "4118", "4166", "4128"],
      "15": ["4307", "4481", "4351", "4367", "4306", "4366", "4328"],
      "20": ["20-4107", "20-4081", "20-4151", "20-4167", "20-4118", "20-4166", "20-4080"],
      "25": ["25-4107", "25-4081", "25-4151", "25-4167", "25-4118", "25-4166", "25-4080"],
      "30": ["30-4307", "30-4481", "30-4351", "30-4367", "30-4318", "30-4366", "30-4380"],
      "40": ["40-4307", "40-4481", "40-4351", "40-4367", "40-4318", "40-4366", "40-4380"],
      "45": ["45-4307", "45-4481", "45-4351", "45-4367", "45-4318", "45-4366", "45-4380"],
    }
  },
  "AngledPlates": {
    "id": "AngledPlates",
    "name": " Angled",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "CrossPlates": {
    "id": "CrossPlates",
    "name": " Cross",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "RectangularPlates": {
    "id": "RectangularPlates",
    "name": " Rectangular",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "RightAnglePlates": {
    "id": "RightAnglePlates",
    "name": " Right Angle",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "SquarePlates": {
    "id": "SquarePlates",
    "name": " Square",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "StraightPlates": {
    "id": "StraightPlates",
    "name": " Straight",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "TeePlates": {
    "id": "TeePlates",
    "name": " Tee",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "TransitionPlates": {
    "id": "TransitionPlates",
    "name": " Transition",
    "children": [
      "S_10-S_15",
      "S_25-S_40"
    ],
    "defaultParts": {}
  },
  "FinishingYourFrame": {
    "id": "FinishingYourFrame",
    "name": " Finishing Your Frame",
    "children": [
      "Organization"
    ],
    "defaultParts": {}
  },
  "Organization": {
    "id": "Organization",
    "name": " Organization",
    "children": [
      "StorageBinHanger",
      "StorageBins"
    ],
    "defaultParts": {}
  },
  "StorageBinHanger": {
    "id": "StorageBinHanger",
    "name": " Storage Bin Hanger",
    "children": [
      "S_10-S_15",
      "S_25-S_30-S_40-S_45"
    ],
    "defaultParts": {}
  },
  "S_25-S_30-S_40-S_45": {
    "id": "S_25-S_30-S_40-S_45",
    "name": " S_25- S_30- S_40- S_45",
    "children": [],
    "defaultParts": {}
  },
  "StorageBins": {
    "id": "StorageBins",
    "name": " Storage Bins",
    "children": [
      "S_10-S_15",
      "S_25-S_40"
    ],
    "defaultParts": {}
  },
  "FloorToFrameComponents": {
    "id": "FloorToFrameComponents",
    "name": "Casters, Feet and Mounts",
    "children": [
      "CastersAndFeet",
      "BasePlates",
    ],
    "defaultParts": {
      ["10"]: ["2333", "2296", "2189", "2182", "2365"],
      ["15"]: ["2333", "2296", "2189", "2182", "2365"],
      ["20"]: ["20-2020", "20-2040", "20-4040"],
      ["25"]: ["25-2525", "25-2550", "25-5050", "25-2503", "25-2502", "25-2504", "25-2501", "25-2527", "25-2514", "25-5013"],
      ["30"]: ["30-3030", "30-3060", "30-6060", "30-3003", "30-3002", "30-3004", "30-3001", "30-3022"],
      ["40"]: ["40-4040", "40-4080", "40-8080", "40-4040-Lite", "40-4080-Lite", "40-4003", "40-4002", "40-4004", "40-4001", "40-4030-Lite"],
      ["45"]: ["45-4545", "45-4590","45-9090", "45-4545-Lite"]
    }
  },
  "2HoleLevelingAnchoringBasePlate": {
    "id": "2HoleLevelingAnchoringBasePlate",
    "name": "2 Hole Leveling Anchoring Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "3HoleCenterTapBasePlate": {
    "id": "3HoleCenterTapBasePlate",
    "name": "3 Hole Center Tap Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "3HoleDieCastCenterTapBasePlate": {
    "id": "3HoleDieCastCenterTapBasePlate",
    "name": "3 Hole Die Cast Center Tap Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "4HoleLevelingAnchoringBasePlate": {
    "id": "4HoleLevelingAnchoringBasePlate",
    "name": "4 Hole Leveling Anchoring Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "4HoleOffsetTapBasePlate": {
    "id": "4HoleOffsetTapBasePlate",
    "name": "4 Hole Offset Tap Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "5HoleCenterTapBasePlate": {
    "id": "5HoleCenterTapBasePlate",
    "name": "5 Hole Center Tap Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "5HoleDieCastCenterTapBasePlate": {
    "id": "5HoleDieCastCenterTapBasePlate",
    "name": "5 Hole Die Cast Center Tap Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "6HoleLevelingAnchoringBasePlate": {
    "id": "6HoleLevelingAnchoringBasePlate",
    "name": "6 Hole Leveling Anchoring Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "EconomyFloorMountBasePlate": {
    "id": "EconomyFloorMountBasePlate",
    "name": "Economy Floor MountBase Plate",
    "children": [],
    "defaultParts": {}
  },
  "FlangeMountCasterBasePlate": {
    "id": "FlangeMountCasterBasePlate",
    "name": "Flange Mount Caster Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "FloorMountBasePlate": {
    "id": "FloorMountBasePlate",
    "name": "Floor Mount Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "HeavyDutyFlangeMountCasterBasePlate": {
    "id": "HeavyDutyFlangeMountCasterBasePlate",
    "name": "Heavy Duty Flange Mount Caster Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "LevelingCasterBasePlate": {
    "id": "LevelingCasterBasePlate",
    "name": "Leveling Caster Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "PositionFloorLockBasePlate": {
    "id": "PositionFloorLockBasePlate",
    "name": "Position Floor Lock Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "SlottedEconomyFloorMountBasePlate": {
    "id": "SlottedEconomyFloorMountBasePlate",
    "name": "SlottedEconomy Floor Mount Base Plate",
    "children": [],
    "defaultParts": {}
  },
  "BasePlates": {
    "id": "BasePlates",
    "name": "Mounting Plates",
    "children": [
      "2HoleLevelingAnchoringBasePlate",
      "3HoleCenterTapBasePlate",
      "3HoleDieCastCenterTapBasePlate",
      "4HoleLevelingAnchoringBasePlate",
      "4HoleOffsetTapBasePlate",
      "5HoleCenterTapBasePlate",
      "5HoleDieCastCenterTapBasePlate",
      "6HoleLevelingAnchoringBasePlate",
      "EconomyFloorMountBasePlate",
      "FlangeMountCasterBasePlate",
      "FloorMountBasePlate",
      "HeavyDutyFlangeMountCasterBasePlate",
      "LevelingCasterBasePlate",
      "PositionFloorLockBasePlate",
      "SlottedEconomyFloorMountBasePlate"
    ],
    "defaultParts": {}
  },
  "EconomyFloorMountBasePlate": {
    "id": "EconomyFloorMountBasePlate",
    "name": " Economy Floor Mount Base Plate",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "FlangeMountCasterBasePlate": {
    "id": "FlangeMountCasterBasePlate",
    "name": " Flange Mount Caster Base Plate",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "FloorMountBasePlate": {
    "id": "FloorMountBasePlate",
    "name": " Floor Mount Base Plate",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "HeavyDutyFlangeMountCasterBasePlate": {
    "id": "HeavyDutyFlangeMountCasterBasePlate",
    "name": " Heavy Duty Flange Mount Caster Base Plate",
    "children": [
      "S_15",
      "S_40"
    ],
    "defaultParts": {}
  },
  "LevelingCasterBasePlate": {
    "id": "LevelingCasterBasePlate",
    "name": " Leveling Caster Base Plate",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "PositionFloorLockBasePlate": {
    "id": "PositionFloorLockBasePlate",
    "name": " Position Floor Lock Base Plate",
    "children": [
      "S_15",
      "S_40"
    ],
    "defaultParts": {}
  },
  "SlottedEconomyFloorMountBasePlate": {
    "id": "SlottedEconomyFloorMountBasePlate",
    "name": " Slotted Economy Floor Mount Base Plate",
    "children": [
      "S_15"
    ],
    "defaultParts": {}
  },
  "CastersAndFeet": {
    "id": "CastersAndFeet",
    "name": " Casters and Feet",
    "children": [
      "Casters",
      "LevelingFeet"
    ],
    "defaultParts": {}
  },
  "Casters": {
    "id": "Casters",
    "name": " Casters",
    "children": [
      "DeluxeFlangeMountRigidCaster",
      "DeluxeFlangeMountSwivelCaster",
      "FlangedMountSwivelCaster",
      "FlangeMountRigidCaster",
      "FurnitureStyleCaster",
      "HeavyDutyFlangeMountRigidCaster",
      "HeavyDutyFlangeMountSwivelCaster",
      "HighCapacityRigidCaster",
      "HighCapacitySwivelCaster",
      "LevelingCasters",
      "ThreadedStemSwivelCaster",
      "TriangularTopPlateCaster"
    ],
    "defaultParts": {}
  },
  "DeluxeFlangeMountRigidCaster": {
    "id": "DeluxeFlangeMountRigidCaster",
    "name": " Deluxe Flange Mount Rigid Caster",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "Metric": {
    "id": "Metric",
    "name": " Metric",
    "children": [],
    "defaultParts": {}
  },
  "DeluxeFlangeMountSwivelCaster": {
    "id": "DeluxeFlangeMountSwivelCaster",
    "name": " Deluxe Flange Mount Swivel Caster",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "FlangedMountSwivelCaster": {
    "id": "FlangedMountSwivelCaster",
    "name": " Flanged Mount Swivel Caster",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "FlangeMountRigidCaster": {
    "id": "FlangeMountRigidCaster",
    "name": " Flange Mount Rigid Caster",
    "children": [
      "S_10-S_15",
      "S_25-S_40"
    ],
    "defaultParts": {}
  },
  "FurnitureStyleCaster": {
    "id": "FurnitureStyleCaster",
    "name": " Furniture Style Caster",
    "children": [
      "Fractional"
    ],
    "defaultParts": {}
  },
  "HeavyDutyFlangeMountRigidCaster": {
    "id": "HeavyDutyFlangeMountRigidCaster",
    "name": " Heavy Duty Flange Mount Rigid Caster",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "HeavyDutyFlangeMountSwivelCaster": {
    "id": "HeavyDutyFlangeMountSwivelCaster",
    "name": " Heavy Duty Flange Mount Swivel Caster",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "HighCapacityRigidCaster": {
    "id": "HighCapacityRigidCaster",
    "name": " High Capacity Rigid Caster",
    "children": [
      "S_15-S_40"
    ],
    "defaultParts": {}
  },
  "S_15-S_40": {
    "id": "S_15-S_40",
    "name": " S_15- S_40",
    "children": [],
    "defaultParts": {}
  },
  "HighCapacitySwivelCaster": {
    "id": "HighCapacitySwivelCaster",
    "name": " High Capacity Swivel Caster",
    "children": [
      "S_15-S_40"
    ],
    "defaultParts": {}
  },
  "LevelingCasters": {
    "id": "LevelingCasters",
    "name": " Leveling Casters",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "ThreadedStemSwivelCaster": {
    "id": "ThreadedStemSwivelCaster",
    "name": " Threaded Stem Swivel Caster",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "TriangularTopPlateCaster": {
    "id": "TriangularTopPlateCaster",
    "name": " Triangular Top Plate Caster",
    "children": [
      "S_15",
      "S_30-S_40-S_45"
    ],
    "defaultParts": {}
  },
  "S_30-S_40-S_45": {
    "id": "S_30-S_40-S_45",
    "name": " S_30- S_40- S_45",
    "children": [],
    "defaultParts": {}
  },
  "LevelingFeet": {
    "id": "LevelingFeet",
    "name": " Leveling Feet",
    "children": [
      "DeluxeLevelingFoot",
      "EconomyAntiVibrationMount",
      "EconomyFloorGlides",
      "EconomyLevelingFoot",
      "LargeBaseGlides",
      "MightyMount",
      "StandardFloorGlides"
    ],
    "defaultParts": {}
  },
  "DeluxeLevelingFoot": {
    "id": "DeluxeLevelingFoot",
    "name": " Deluxe Leveling Foot",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "EconomyAntiVibrationMount": {
    "id": "EconomyAntiVibrationMount",
    "name": " Economy Anti Vibration Mount",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "EconomyFloorGlides": {
    "id": "EconomyFloorGlides",
    "name": " Economy Floor Glides",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "EconomyLevelingFoot": {
    "id": "EconomyLevelingFoot",
    "name": " Economy Leveling Foot",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "LargeBaseGlides": {
    "id": "LargeBaseGlides",
    "name": " Large Base Glides",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "MightyMount": {
    "id": "MightyMount",
    "name": " Mighty Mount",
    "children": [
      "Fractional",
      "Metric"
    ],
    "defaultParts": {}
  },
  "StandardFloorGlides": {
    "id": "StandardFloorGlides",
    "name": " Standard Floor Glides",
    "children": [
      "Fractional"
    ],
    "defaultParts": {}
  },
  "InternalFasteners": {
    "id": "InternalFasteners",
    "name": " Internal Connecters",
    "children": [
      "Metric",
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "DoorComponents": {
    "id": "DoorComponents",
    "name": "Door Components",
    "children": [
      "Handles",
      // "Hinges",
      // "LatchesAndCatches",
      // "BlocksAndClamps",
    ],
    "defaultParts": {}
  },
  "PanelsAndTableTops": {
    "id": "PanelsAndTableTops",
    "name": "Panels and Table Tops",
    "children": [
      "Panels",
      "PanelAndMeshMounts"
    ],
    "defaultParts": {}
  },
  "Panels": {
    "id": "Panels",
    "name": "Panels",
    "children": [],
    "defaultParts": {}
  },
  "Handles": {
    "id": "Handles",
    "name": " Handles",
    "children": [
      // "AluminumDoorHandle",
      // "PlasticDoorHandle"
    ],
    "defaultParts": {}
  },
  "AluminumDoorHandle": {
    "id": "AluminumDoorHandle",
    "name": " Aluminum Door Handle",
    "children": [
      "S_25-S_30-S_40-S_45"
    ],
    "defaultParts": {}
  },
  "PlasticDoorHandle": {
    "id": "PlasticDoorHandle",
    "name": " Plastic Door Handle",
    "children": [
      "S_10",
      "S_15",
      "S_25-S_30",
      "S_40"
    ],
    "defaultParts": {}
  },
  "S_25-S_30": {
    "id": "S_25-S_30",
    "name": " S_25- S_30",
    "children": [],
    "defaultParts": {}
  },
  "Hinges": {
    "id": "Hinges",
    "name": " Hinges",
    "children": [
      "2HolePlasticLiftOffHinge",
      "3HolePlasticDoubleLiftOffHinge",
      "4HoleConcealedHinge",
      "4HoleDualHandLiftOffHinge",
      "4HolePlasticLiftOffHinge",
      "EconomyLiftOffHingeAssembly",
      "EconomyLiftOffHingeLeftHandWithLongPin",
      "EconomyLiftOffHingeLeftHandWithShortPin",
      "EconomyLiftOffHingeRightHandWithLongPin",
      "EconomyLiftOffHingeRightHandWithShortPin"
    ],
    "defaultParts": {}
  },
  "S_10-S_25-S_30": {
    "id": "S_10-S_25-S_30",
    "name": " S_10- S_25- S_30",
    "children": [],
    "defaultParts": {}
  },
  "EconomyLiftOffHingeAssembly": {
    "id": "EconomyLiftOffHingeAssembly",
    "name": " Economy Lift Off Hinge Assembly",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "EconomyLiftOffHingeLeftHandWithLongPin": {
    "id": "EconomyLiftOffHingeLeftHandWithLongPin",
    "name": " Economy Lift Off Hinge Left Hand With Long Pin",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "EconomyLiftOffHingeLeftHandWithShortPin": {
    "id": "EconomyLiftOffHingeLeftHandWithShortPin",
    "name": " Economy Lift Off Hinge Left Hand With Short Pin",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "EconomyLiftOffHingeRightHandWithLongPin": {
    "id": "EconomyLiftOffHingeRightHandWithLongPin",
    "name": " Economy Lift Off Hinge Right Hand With Long Pin",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "EconomyLiftOffHingeRightHandWithShortPin": {
    "id": "EconomyLiftOffHingeRightHandWithShortPin",
    "name": " Economy Lift Off Hinge Right Hand With Short Pin",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "LatchesAndCatches": {
    "id": "LatchesAndCatches",
    "name": " Latches and Catches",
    "children": [
      "0DegreeDeadboltLatch",
      "90DegreeDeadboltLatch"
    ],
    "defaultParts": {}
  },
  "S_25-S_30-S_40": {
    "id": "S_25-S_30-S_40",
    "name": " S_25- S_30- S_40",
    "children": [],
    "defaultParts": {}
  },
  "PanelAndMeshMounts": {
    "id": "PanelAndMeshMounts",
    "name": " Panel Mounts",
    "children": [
      "MountingBrackets",
      "PanelAndMeshRetainers"
    ],
    "defaultParts": {}
  },
  "BlocksAndClamps": {
    "id": "BlocksAndClamps",
    "name": " Blocks and Clamps",
    "children": [
      "AluminumPanelMountBlock",
      "DetentHingeStopper",
      "DropInLitePanelMountBlock",
      "LitePanelMountBlock",
      "LitePanelMountBlockSpacer",
      "QuickChangePanelClamp"
    ],
    "defaultParts": {}
  },
  "AluminumPanelMountBlock": {
    "id": "AluminumPanelMountBlock",
    "name": " Aluminum Panel Mount Block",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "DetentHingeStopper": {
    "id": "DetentHingeStopper",
    "name": " Detent Hinge Stopper",
    "children": [
      "S_10-S_15",
      "S_25-S_45"
    ],
    "defaultParts": {}
  },
  "S_25-S_45": {
    "id": "S_25-S_45",
    "name": " S_25- S_45",
    "children": [],
    "defaultParts": {}
  },
  "DropInLitePanelMountBlock": {
    "id": "DropInLitePanelMountBlock",
    "name": " Drop In Lite Panel Mount Block",
    "children": [
      "S_15-S_40",
      "S_20",
      "S_30",
      "S_45"
    ],
    "defaultParts": {}
  },
  "LitePanelMountBlock": {
    "id": "LitePanelMountBlock",
    "name": " Lite Panel Mount Block",
    "children": [
      "S_15-S_30-S_40-S_45"
    ],
    "defaultParts": {}
  },
  "S_15-S_30-S_40-S_45": {
    "id": "S_15-S_30-S_40-S_45",
    "name": " S_15- S_30- S_40- S_45",
    "children": [],
    "defaultParts": {}
  },
  "LitePanelMountBlockSpacer": {
    "id": "LitePanelMountBlockSpacer",
    "name": " Lite Panel Mount Block Spacer",
    "children": [
      "S_15-S_30-S_40-S_45"
    ],
    "defaultParts": {}
  },
  "QuickChangePanelClamp": {
    "id": "QuickChangePanelClamp",
    "name": " Quick Change Panel Clamp",
    "children": [
      "S_15",
      "S_40"
    ],
    "defaultParts": {}
  },
  "MountingBrackets": {
    "id": "MountingBrackets",
    "name": " Mounting Brackets",
    "children": [
      // "AdjustablePanelMountBracket",
      // "PanelMountBrackets",
      // "RollInPanelMountBrackets"
    ],
    "defaultParts": {}
  },
  "AdjustablePanelMountBracket": {
    "id": "AdjustablePanelMountBracket",
    "name": " Adjustable Panel Mount Bracket",
    "children": [
      "S_15-S_40"
    ],
    "defaultParts": {}
  },
  "PanelMountBrackets": {
    "id": "PanelMountBrackets",
    "name": " Panel Mount Brackets",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "RollInPanelMountBrackets": {
    "id": "RollInPanelMountBrackets",
    "name": " Roll In Panel Mount Brackets",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "PanelAndMeshRetainers": {
    "id": "PanelAndMeshRetainers",
    "name": " Panel Retainers",
    "children": [
      // "DoubleArmNarrowMeshRetainer",
      // "DoubleArmNarrowPanelRetainer",
      // "DoubleArmWideMeshRetainer",
      // "NarrowBackingPlate",
      // "RollInMeshPanelRetainer",
      // "SingleArmNarrowMeshRetainer",
      // "SingleArmNarrowPanelRetainer",
      // "SingleArmWideMeshRetainer",
      // "SingleArmWidePanelRetainer",
      // "SinglePanelHolder",
      // "WideBackingPlate"
    ],
    "defaultParts": {}
  },
  "DoubleArmNarrowMeshRetainer": {
    "id": "DoubleArmNarrowMeshRetainer",
    "name": " Double Arm Narrow Mesh Retainer",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "DoubleArmNarrowPanelRetainer": {
    "id": "DoubleArmNarrowPanelRetainer",
    "name": " Double Arm Narrow Panel Retainer",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "DoubleArmWideMeshRetainer": {
    "id": "DoubleArmWideMeshRetainer",
    "name": " Double Arm Wide Mesh Retainer",
    "children": [
      "S_10",
      "S_15",
      "S_25",
      "S_40"
    ],
    "defaultParts": {}
  },
  "NarrowBackingPlate": {
    "id": "NarrowBackingPlate",
    "name": " Narrow Backing Plate",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "RollInMeshPanelRetainer": {
    "id": "RollInMeshPanelRetainer",
    "name": " Roll In Mesh Panel Retainer",
    "children": [
      "S_15-S_40"
    ],
    "defaultParts": {}
  },
  "SingleArmNarrowMeshRetainer": {
    "id": "SingleArmNarrowMeshRetainer",
    "name": " Single Arm Narrow Mesh Retainer",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "SingleArmNarrowPanelRetainer": {
    "id": "SingleArmNarrowPanelRetainer",
    "name": " Single Arm Narrow Panel Retainer",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "SingleArmWideMeshRetainer": {
    "id": "SingleArmWideMeshRetainer",
    "name": " Single Arm Wide Mesh Retainer",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "SingleArmWidePanelRetainer": {
    "id": "SingleArmWidePanelRetainer",
    "name": " Single Arm Wide Panel Retainer",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "SinglePanelHolder": {
    "id": "SinglePanelHolder",
    "name": " Single Panel Holder",
    "children": [
      "S_10-S_15",
      "S_25-S_40"
    ],
    "defaultParts": {}
  },
  "WideBackingPlate": {
    "id": "WideBackingPlate",
    "name": " Wide Backing Plate",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {}
  },
  "Hardware": {
    "id": "Hardware",
    "name": "Hardware",
    "children": [
      "TNuts",
      "Bolts",
      "HexNuts",
      "Washers",
    ],
    "defaultParts": {
      ["10"]: ["3382", "3059", "3208", "3258"],
      ["15"]: ["3278", "3104", "3214", "3260"],
      ["20"]: ["14122", "11-5308", "11-5065", "11-6040"],
      ["25"]: ["25-1961", "11-6310", "11-6065", "11-6041"],
      ["30"]: ["30-1961", "11-6310", "11-6065", "11-6041"],
      ["40"]: ["40-1981", "11-8312", "11-8065", "11-6042"],
      ["45"]:["14129", "11-8312", "11-8065", "11-6042"]
    }
  },
  "Bolts": {
    "id": "Bolts",
    "name": "Bolts",
    "children": [],
    "defaultParts": {}
  },
  "TNuts": {
    "id": "TNuts",
    "name": "TNuts",
    "children": [],
    "defaultParts": {}
  },
  "HexNuts": {
    "id": "HexNuts",
    "name": "HexNuts",
    "children": [],
    "defaultParts": {}
  },
  "Washers": {
    "id": "Washers",
    "name": "Washers",
    "children": [],
    "defaultParts": {}
  },
  "T-SlottedProfiles": {
    "id": "T-SlottedProfiles",
    "name": "Aluminum Extrusion",
    "children": [
      "S_10",
      "S_15",
      "S_20",
      "S_25",
      "S_30",
      "S_40",
      "S_45"
    ],
    "defaultParts": {
      ["10"]: ["1010-S", "1020-S", "2020-S", "1003-S", "1002-S", "1004-S", "1001-S", "1012-S", "1050", "2012"],
      ["15"]: ["1515-S", "1530-S", "3030-S", "1503-LS", "1502-LS", "1504-LS", "1501-LS", "1517-LS", "1575", "3075"],
      ["20"]: ["20-2020", "20-2040", "20-4040"],
      ["25"]: ["25-2525", "25-2550", "25-5050", "25-2503", "25-2502", "25-2504", "25-2501", "25-2527", "25-2514", "25-5013"],
      ["30"]: ["30-3030", "30-3060", "30-6060", "30-3003", "30-3002", "30-3004", "30-3001", "30-3022"],
      ["40"]: ["40-4040", "40-4080", "40-8080", "40-4040-Lite", "40-4080-Lite", "40-4003", "40-4002", "40-4004", "40-4001", "40-4030-Lite"],
      ["45"]: ["45-4545", "45-4590","45-9090", "45-4545-Lite"]
    }
  },
  "Wood": {
    "id": "Wood",
    "name": "Wood",
    "children": [
      "Boards",
      "Plywood"
    ],
    "defaultParts": {
      ["ALL"]: ["2x4", "2x6", "2x8", "2x10", "2x12", "4x4"],
    }
  },
  "Boards": {
    "id": "Boards",
    "name": "Boards",
    "children": [
      "1X",
      "2X",
      "4X",
    ],
    "defaultParts": {
      ["ALL"]: ["2x4", "2x6", "2x8", "2x10", "2x12", "4x4"],
    }
  },
  "1X": {
    "id": "1X",
    "name": "1\" Boards",
    "children": [],
    "defaultParts": {
      ["ALL"]: ["1x2", "1x3", "1x4", "1x6", "1x8", "1x10", "1x12"],
    }
  },
  "2X": {
    "id": "2X",
    "name": "2\" Boards",
    "children": [],
    "defaultParts": {
      ["ALL"]: ["2x2", "2x3", "2x4", "2x6", "2x8", "2x10", "2x12"],
    }
  },
  "4X": {
    "id": "4X",
    "name": "4\" Boards",
    "children": [],
    "defaultParts": {
      ["ALL"]: ["4x4", "4x6", "4x8", "4x10", "4x12"],
    }
  },
  "Plywood": {
    "id": "Plywood",
    "name": "Plywood",
    "children": [],
    "defaultParts": {
      ["ALL"]: ["ply_1-8in", "ply_1-4in", "ply_3-8in", "ply_1-2in", "ply_5-8in", "ply_3-4in"],
    }
  },
  "Simulators": {
    "id": "Simulators",
    "name": "Simulators",
    "children": [
      "Racing",
      "Flight"
    ],
    "defaultParts": {}
  },
  "Racing": {
    "id": "Racing",
    "name": "Racing",
    "children": [
      "Seats",
      "Wheels",
      "Shifters",
      "Pedals",
    ],
    "defaultParts": {}
  },
  "Flight": {
    "id": "Flight",
    "name": "Flight",
    "children": [
      "Seats",
    ],
    "defaultParts": {}
  },
  "Seats": {
    "id": "Seats",
    "name": "Seats",
    "children": [],
    "defaultParts": {}
  },
  "Wheels": {
    "id": "Wheels",
    "name": "Wheels",
    "children": [],
    "defaultParts": {}
  },
  "Shifters": {
    "id": "Shifters",
    "name": "Shifters",
    "children": [],
    "defaultParts": {}
  },
  "Pedals": {
    "id": "Pedals",
    "name": "Pedals",
    "children": [],
    "defaultParts": {}
  },
  "Aluminum": {
    "id": "Aluminum",
    "name": "Aluminum",
    "children": [
      "T-SlottedProfiles",
      "ExternalFasteners",
      "InternalFasteners",
      "AddingMotion",
      "TNuts",
    ],
    "defaultParts": {
      ["10"]: ["1010-S", "1020-S", "2020-S", "1003-S", "1002-S", "1004-S", "1001-S", "1012-S", "1050", "2012"],
      ["15"]: ["1515-S", "1530-S", "3030-S", "1503-LS", "1502-LS", "1504-LS", "1501-LS", "1517-LS", "1575", "3075"],
      ["20"]: ["20-2020", "20-2040", "20-4040"],
      ["25"]: ["25-2525", "25-2550", "25-5050", "25-2503", "25-2502", "25-2504", "25-2501", "25-2527", "25-2514", "25-5013"],
      ["30"]: ["30-3030", "30-3060", "30-6060", "30-3003", "30-3002", "30-3004", "30-3001", "30-3022"],
      ["40"]: ["40-4040", "40-4080", "40-8080", "40-4040-Lite", "40-4080-Lite", "40-4003", "40-4002", "40-4004", "40-4001", "40-4030-Lite"],
      ["45"]: ["45-4545", "45-4590","45-9090", "45-4545-Lite"]
    }
  }
}